export default __webpack_public_path__ + "static/media/login.5c01ce36.svg";